import gql from "graphql-tag";
const UPDATE_CONTEST = gql `
  mutation updateContest($id: ID!, $contestUpdateInput: ContestUpdateInput!) {
    updateContest(id: $id, contestUpdateInput: $contestUpdateInput) {
      id
    }
  }
`;
export default UPDATE_CONTEST;
